var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header__col header__col_logo"},[_c('div',{staticClass:"header__logo"},[_c('RouterLink',{staticClass:"header__logo-src",attrs:{"to":{ name: 'services' }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }